import { render } from "./AppInputText.vue?vue&type=template&id=2fce9452&ts=true"
import script from "./AppInputText.vue?vue&type=script&lang=ts"
export * from "./AppInputText.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/wVusKqw4/0/kenniss/platform/educator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__